import type { ReactNode } from 'react';

import { Icon, type IconName } from './icons';

// EmptyState: leerer Bereich mit kurzer Erklärung und – wo möglich – dem nächsten Schritt (action).
export function EmptyState({ title, children, action, icon = 'check' }: { title: string; children?: ReactNode; action?: ReactNode; icon?: IconName }) {
  return (
    <div className="empty-state">
      <span className="empty-state-icon" aria-hidden="true">
        <Icon name={icon} size={22} />
      </span>
      <h2>{title}</h2>
      {children && <div className="muted">{children}</div>}
      {action && <div className="empty-state-action">{action}</div>}
    </div>
  );
}
